import Reading from '../models/reading';

import ArcanumUnbounded from '../assets/images/squad/david/books/arcanumUnbounded.jpg';
import Alchemist from '../assets/images/squad/david/books/alchemist.jpg';
import AlloyLaw from '../assets/images/squad/david/books/alloyLaw.jpg';
import AllWorlds from '../assets/images/squad/david/books/allWorlds.jpg';
import America from '../assets/images/squad/david/books/america.jpg';
import AmericaAgain from '../assets/images/squad/david/books/americaAgain.jpg';
import Animal from '../assets/images/squad/david/books/animal.jpg';
import ArtHappiness from '../assets/images/squad/david/books/artHappiness.jpg';
import Arthas from '../assets/images/squad/david/books/arthas.jpg';
import ArtWar from '../assets/images/squad/david/books/artWar.jpg';
import Bakemonogatari1 from '../assets/images/squad/david/books/bakemonogatari1.jpg';
import Bakemonogatari2 from '../assets/images/squad/david/books/bakemonogatari2.jpg';
import BandsMourning from '../assets/images/squad/david/books/bandsMourning.jpg';
import BeakFinch from '../assets/images/squad/david/books/beakFinch.jpg';
import BeerHell from '../assets/images/squad/david/books/beerHell.jpg';
import Beyond from '../assets/images/squad/david/books/beyond.jpg';
import Blink from '../assets/images/squad/david/books/blink.jpg';
import BrainMythNeuro from '../assets/images/squad/david/books/brainMythNeuro.jpg';
import BoysBoat from '../assets/images/squad/david/books/boysBoat.jpg';
import Calories from '../assets/images/squad/david/books/calories.jpg';
import Change from '../assets/images/squad/david/books/change.jpg';
import ChildrenMind from '../assets/images/squad/david/books/childrenMind.jpg';
import ClashKings from '../assets/images/squad/david/books/clashKings.jpg';
import Clean from '../assets/images/squad/david/books/clean.jpg';
import Code from '../assets/images/squad/david/books/code.jpg';
import Colbert from '../assets/images/squad/david/books/colbert.jpg';
import Comics from '../assets/images/squad/david/books/comics.jpg';
import CompassPleasure from '../assets/images/squad/david/books/compassPleasure.jpg';
import Cooked from '../assets/images/squad/david/books/cooked.jpg';
import Daemon from '../assets/images/squad/david/books/daemon.jpg';
import DanceDragons from '../assets/images/squad/david/books/danceDragons.jpg';
import DarkAge from '../assets/images/squad/david/books/darkAge.jpg';
import DarkMatter from '../assets/images/squad/david/books/darkMatter.jpg';
import DavidGoliath from '../assets/images/squad/david/books/davidGoliath.jpg';
import Dawnshard from '../assets/images/squad/david/books/dawnshard.jpg';
import Decoded from '../assets/images/squad/david/books/decoded.jpg';
import DesignThings from '../assets/images/squad/david/books/designThings.jpg';
import DevOps from '../assets/images/squad/david/books/devOps.jpg';
import DoubleHelix from '../assets/images/squad/david/books/doubleHelix.jpg';
import Drive from '../assets/images/squad/david/books/drive.jpg';
import Dune from '../assets/images/squad/david/books/dune.jpg';
import Earth from '../assets/images/squad/david/books/earth.jpg';
import Edgedancer from '../assets/images/squad/david/books/edgedancer.jpg';
import Einstein from '../assets/images/squad/david/books/einstein.jpg';
import Elantris from '../assets/images/squad/david/books/elantris.jpg';
import EndersGame from '../assets/images/squad/david/books/endersGame.jpg';
import EnderShadow from '../assets/images/squad/david/books/enderShadow.jpg';
import EndThings from '../assets/images/squad/david/books/endThings.jpg';
import EngineeringPlay from '../assets/images/squad/david/books/engineeringPlay.jpg';
import Exp1Leviathan from '../assets/images/squad/david/books/exp1Leviathan.jpg';
import Exp2Caliban from '../assets/images/squad/david/books/exp2Caliban.jpg';
import Exp3Abaddon from '../assets/images/squad/david/books/exp3Abaddon.jpg';
import Exp4Cibola from '../assets/images/squad/david/books/exp4Cibola.jpg';
import Exp5Nemesis from '../assets/images/squad/david/books/exp5Nemesis.jpg';
import Exp6Babylons from '../assets/images/squad/david/books/exp6Babylons.jpg';
import FeastCrows from '../assets/images/squad/david/books/feastCrows.jpg';
import FifthSeason from '../assets/images/squad/david/books/fifthSeason.jpg';
import Flow from '../assets/images/squad/david/books/flow.jpg';
import Folded from '../assets/images/squad/david/books/folded.jpg';
import FoodRules from '../assets/images/squad/david/books/foodRules.jpg';
import Freakonomics from '../assets/images/squad/david/books/freakonomics.jpg';
import Freedom from '../assets/images/squad/david/books/freedom.jpg';
import GameBelieves from '../assets/images/squad/david/books/gameBelieves.jpg';
import GameFrame from '../assets/images/squad/david/books/gameFrame.jpg';
import GameThrones from '../assets/images/squad/david/books/gameThrones.jpg';
import GamificationLearning from '../assets/images/squad/david/books/gamificationLearning.jpg';
import GenerationKill from '../assets/images/squad/david/books/generationKill.jpg';
import GenghisKhan from '../assets/images/squad/david/books/genghisKhan.jpg';
import GhostBrigades from '../assets/images/squad/david/books/ghostBrigades.jpg';
import GoldenSun from '../assets/images/squad/david/books/goldenSun.jpg';
import GunsGerms from '../assets/images/squad/david/books/gunsGerms.jpg';
import Habit from '../assets/images/squad/david/books/habit.jpg';
import HailMary from '../assets/images/squad/david/books/hailMary.jpg';
import Healthy from '../assets/images/squad/david/books/healthy.jpg';
import HeavenReal from '../assets/images/squad/david/books/heavenReal.jpg';
import HeavensRiver from '../assets/images/squad/david/books/heavensRiver.jpg';
import HistoryTime from '../assets/images/squad/david/books/historyTime.jpg';
import Hokkaido from '../assets/images/squad/david/books/hokkaido.jpg';
import HumanDivision from '../assets/images/squad/david/books/humanDivision.jpg';
import IceFire from '../assets/images/squad/david/books/iceFire.jpg';
import Illidan from '../assets/images/squad/david/books/illidan.jpg';
import Imagine from '../assets/images/squad/david/books/imagine.jpg';
import Immune from '../assets/images/squad/david/books/immune.jpg';
import Incognito from '../assets/images/squad/david/books/incognito.jpg';
import IntelNature from '../assets/images/squad/david/books/intelNature.jpg';
import IronGold from '../assets/images/squad/david/books/ironGold.jpg';
import KillingKennedy from '../assets/images/squad/david/books/killingKennedy.jpg';
import LastColony from '../assets/images/squad/david/books/lastColony.jpg';
import LeanStartup from '../assets/images/squad/david/books/leanStartup.jpg';
import LordsSith from '../assets/images/squad/david/books/lordsSith.jpg';
import LostMetal from '../assets/images/squad/david/books/lostMetal.jpg';
import ManPlay from '../assets/images/squad/david/books/manPlay.jpg';
import Martian from '../assets/images/squad/david/books/martian.jpg';
import Mindsight from '../assets/images/squad/david/books/mindsight.jpg';
import MindsOnline from '../assets/images/squad/david/books/mindsOnline.jpg';
import Mistborn1 from '../assets/images/squad/david/books/mistborn1.jpg';
import Mistborn2 from '../assets/images/squad/david/books/mistborn2.jpg';
import Mistborn3 from '../assets/images/squad/david/books/mistborn3.jpg';
import MorningStar from '../assets/images/squad/david/books/morningStar.jpg';
import Mueller from '../assets/images/squad/david/books/mueller.jpg';
import Neighbors from '../assets/images/squad/david/books/neighbors.jpg';
import Nausea from '../assets/images/squad/david/books/nausea.jpg';
import NeverSplit from '../assets/images/squad/david/books/neverSplit.jpg';
import Nonzero from '../assets/images/squad/david/books/nonzero.jpg';
import Oathbringer from '../assets/images/squad/david/books/oathbringer.jpg';
import ObeliskGate from '../assets/images/squad/david/books/obeliskGate.jpg';
import OldManWar from '../assets/images/squad/david/books/oldManWar.jpg';
import OmnivoreDilemma from '../assets/images/squad/david/books/omnivoreDilemma.jpg';
import OneHundredTwentyYear from '../assets/images/squad/david/books/120year.jpg';
import OneSecond from '../assets/images/squad/david/books/oneSecond.jpg';
import Outliers from '../assets/images/squad/david/books/outliers.jpg';
import PeoplesHistory from '../assets/images/squad/david/books/peoplesHistory.jpg';
import ProdigalGod from '../assets/images/squad/david/books/prodigalGod.jpg';
import ProgramProgrammed from '../assets/images/squad/david/books/programProgrammed.jpg';
import PsychZelda from '../assets/images/squad/david/books/psychZelda.jpg';
import ReadyPlayer from '../assets/images/squad/david/books/readyPlayer.jpg';
import ReadyP2 from '../assets/images/squad/david/books/readyP2.jpg';
import RealFood from '../assets/images/squad/david/books/realFood.jpg';
import RealityBroken from '../assets/images/squad/david/books/realityBroken.jpg';
import RedNotice from '../assets/images/squad/david/books/redNotice.jpg';
import RedRising from '../assets/images/squad/david/books/redRising.jpg';
import RhythmWar from '../assets/images/squad/david/books/rhythmWar.jpg';
import Roadkill from '../assets/images/squad/david/books/roadkill.jpg';
import Sandman from '../assets/images/squad/david/books/sandman.jpg';
import Sandman2 from '../assets/images/squad/david/books/sandman2.jpg';
import Sandman3 from '../assets/images/squad/david/books/sandman3.jpg';
import Sapiens from '../assets/images/squad/david/books/sapiens.jpg';
import SDVBible from '../assets/images/squad/david/books/sdvBible.jpg';
import SearchSchrodinger from '../assets/images/squad/david/books/searchSchrodinger.jpg';
import Secret from '../assets/images/squad/david/books/secret.jpg';
import Self from '../assets/images/squad/david/books/self.jpg';
import SelfishGene from '../assets/images/squad/david/books/selfishGene.jpg';
import SeventeenSevenitySix from '../assets/images/squad/david/books/1776.jpg';
import ShadowGiant from '../assets/images/squad/david/books/shadowGiant.jpg';
import ShadowHegemon from '../assets/images/squad/david/books/shadowHegemon.jpg';
import ShadowPuppets from '../assets/images/squad/david/books/shadowPuppets.jpg';
import ShadowsSelf from '../assets/images/squad/david/books/shadowsSelf.jpg';
import SpeakerDead from '../assets/images/squad/david/books/speakerDead.jpg';
import SpontaneousEvolution from '../assets/images/squad/david/books/spontaneousEvolution.jpg';
import Stillness from '../assets/images/squad/david/books/stillness.jpg';
import StoneSky from '../assets/images/squad/david/books/stoneSky.jpg';
import StormSwords from '../assets/images/squad/david/books/stormSwords.jpg';
import StoryMuhammed from '../assets/images/squad/david/books/storyMuhammed.jpg';
import StrokeInsight from '../assets/images/squad/david/books/strokeInsight.jpg';
import Subliminal from '../assets/images/squad/david/books/subliminal.jpg';
import SunsetLimited from '../assets/images/squad/david/books/sunsetLimited.jpg';
import SuperFreak from '../assets/images/squad/david/books/superFreak.jpg';
import Superman from '../assets/images/squad/david/books/superman.jpg';
import ThinAir from '../assets/images/squad/david/books/thinAir.jpg';
import Thinking from '../assets/images/squad/david/books/thinking.jpg';
import Thrawn from '../assets/images/squad/david/books/thrawn.jpg';
import ThrawnAlliances from '../assets/images/squad/david/books/thrawnAlliances.jpg';
import ThrawnAscendancy1 from '../assets/images/squad/david/books/thrawnAscendancy1.jpg';
import ThrawnAscendancy2 from '../assets/images/squad/david/books/thrawnAscendancy2.jpg';
import ThrawnAscendancy3 from '../assets/images/squad/david/books/thrawnAscendancy3.jpg';
import ThrawnTeason from '../assets/images/squad/david/books/thrawnTreason.jpg';
import TippingPoint from '../assets/images/squad/david/books/tippingPoint.jpg';
import Tress from '../assets/images/squad/david/books/tress.jpg';
import Vehicles from '../assets/images/squad/david/books/vehicles.jpg';
import Watchmen from '../assets/images/squad/david/books/watchmen.jpg';
import Warbreaker from '../assets/images/squad/david/books/warbreaker.jpg';
import WayOfKings from '../assets/images/squad/david/books/wayOfKings.jpg';
import WeBob from '../assets/images/squad/david/books/weBob.jpg';
import WeMany from '../assets/images/squad/david/books/weMany.jpg';
import WhySleep from '../assets/images/squad/david/books/whySleep.jpg';
import Wisdom from '../assets/images/squad/david/books/wisdom.jpg';
import WordsRadiance from '../assets/images/squad/david/books/wordsRadiance.jpg';
import WorldFat from '../assets/images/squad/david/books/worldFat.jpg';
import Xenocide from '../assets/images/squad/david/books/xenocide.jpg';
import ZoesTale from '../assets/images/squad/david/books/zoesTale.jpg';

export const READINGSLIST = [
    new Reading (
        DarkMatter.toString(), 
        'Dark Matter',
        DarkMatter, 
        'https://www.amazon.com/Dark-Matter-Novel-Blake-Crouch/dp/1101904240',
        179
    ),
    new Reading (
        Tress.toString(), 
        'Tres of the Emerald Sea',
        Tress, 
        'https://www.amazon.com/Tress-Emerald-Sea-Brandon-Sanderson/dp/1250899656',
        178
    ),
    new Reading (
        EndThings.toString(), 
        'The End of All Things',
        EndThings, 
        'https://www.amazon.com/End-All-Things-Old-Mans/dp/0765376105',
        177
    ),
    new Reading (
        ArcanumUnbounded.toString(), 
        'Arcanum Unbounded',
        ArcanumUnbounded, 
        'https://www.amazon.com/Arcanum-Unbounded-Collection-Brandon-Sanderson/dp/0765391163',
        176
    ),
    new Reading (
        HumanDivision.toString(), 
        'The Human Division',
        HumanDivision, 
        'https://www.amazon.com/Human-Division-Old-Mans-War/dp/0765369559',
        175
    ),
    new Reading (
        Illidan.toString(), 
        'Illidan: World of Warcraft (A Novel)',
        Illidan, 
        'https://www.amazon.com/Illidan-World-Warcraft-William-King/dp/0399177574',
        174
    ),
    new Reading (
        LostMetal.toString(), 
        'The Lost Metal',
        LostMetal, 
        'https://www.amazon.com/Lost-Metal-Mistborn-Novel-Saga/dp/0765391198',
        173
    ),
    new Reading (
        BandsMourning.toString(), 
        'The Bands of Mourning',
        BandsMourning, 
        'https://www.amazon.com/Bands-Mourning-Mistborn-Novel-ebook/dp/B00R697BC8',
        172
    ),
    new Reading (
        Exp6Babylons.toString(), 
        'Babylon\'s Ashes (The Expanse 6)',
        Exp6Babylons, 
        'https://www.amazon.com/Babylons-Ashes-Expanse-James-Corey/dp/031633474X',
        171
    ),
    new Reading (
        ShadowsSelf.toString(), 
        'Shadows of Self',
        ShadowsSelf, 
        'https://www.amazon.com/Shadows-Self-Mistborn-Brandon-Sanderson/dp/0765378566',
        170
    ),
    new Reading (
        AlloyLaw.toString(), 
        'The Alloy of Law',
        AlloyLaw, 
        'https://www.amazon.com/Alloy-Law-Mistborn-Novel/dp/0765368544',
        169
    ),
    new Reading (
        ZoesTale.toString(), 
        'Zoe\'s Tale',
        ZoesTale, 
        'https://www.amazon.com/Zoes-Tale-Old-Mans-Novel/dp/0765356198',
        168
    ),
    new Reading (
        Exp5Nemesis.toString(), 
        'Nemesis Games (The Expanse 5)',
        Exp5Nemesis, 
        'https://www.amazon.com/Nemesis-Games-Expanse-James-Corey/dp/0316334715',
        167
    ),
    new Reading (
        LastColony.toString(), 
        'The Last Colony',
        LastColony, 
        'https://www.amazon.com/Last-Colony-Old-Mans-War/dp/076535618X',
        166
    ),
    new Reading (
        Roadkill.toString(), 
        'Roadkill',
        Roadkill, 
        'https://www.amazon.com/Audible-Roadkill/dp/B0B6Q8TW1Y',
        165
    ),
    new Reading (
        Elantris.toString(), 
        'Elantris',
        Elantris, 
        'https://www.amazon.com/Elantris-Brandon-Sanderson/dp/0765350378',
        164
    ),
    new Reading (
        BrainMythNeuro.toString(), 
        'Brain Myths Exploded: Lessons from Neuroscience',
        BrainMythNeuro, 
        'https://www.amazon.com/Brain-Myths-Exploded-Lessons-Neuroscience/dp/162997370X',
        163
    ),
    new Reading (
        Warbreaker.toString(), 
        'Warbreaker',
        Warbreaker, 
        'https://www.amazon.com/Warbreaker-Brandon-Sanderson/dp/0765360039',
        162
    ),
    new Reading (
        Exp4Cibola.toString(), 
        'Cibola Burn (The Expanse 4)',
        Exp4Cibola, 
        'https://www.amazon.com/Cibola-Burn-Expanse-Book-4-ebook/dp/B00FPQA4F0',
        161
    ),
    new Reading (
        DevOps.toString(), 
        'The DevOps Handbook, 2nd Ed.',
        DevOps, 
        'https://www.amazon.com/DevOps-Handbook-Second-World-Class-Organizations/dp/B09L56CT6N',
        160
    ),
    new Reading (
        Sandman3.toString(), 
        'The Sandman: Act III',
        Sandman3, 
        'https://www.audible.com/pd/The-Sandman-Act-III-Audiobook/B0BFK1K36D',
        159
    ),
    new Reading (
        GhostBrigades.toString(), 
        'The Ghost Brigades',
        GhostBrigades, 
        'https://www.amazon.com/Ghost-Brigades-Old-Mans-War/dp/0765354063',
        158
    ),
    new Reading (
        Mistborn3.toString(), 
        'Mistborn: The Hero of Ages',
        Mistborn3, 
        'https://www.amazon.com/Hero-Ages-Book-Three-Mistborn-ebook/dp/B002LC8HF0',
        157
    ),
    new Reading (
        Mistborn2.toString(), 
        'Mistborn: The Well of Ascension',
        Mistborn2, 
        'https://www.amazon.com/Well-Ascension-Book-Two-Mistborn-ebook/dp/B000UZQI0Q',
        156
    ),
    new Reading (
        Mistborn1.toString(), 
        'Mistborn: The Final Empire',
        Mistborn1, 
        'https://www.amazon.com/Mistborn-Final-Empire-Book-No/dp/0765350386',
        155
    ),
    new Reading (
        Superman.toString(), 
        'The Rise of Superman',
        Superman, 
        'https://www.amazon.com/Rise-Superman-Decoding-Ultimate-Performance-ebook/dp/B00BW54XVO',
        154
    ),
    new Reading (
        Edgedancer.toString(), 
        'Edgedancer',
        Edgedancer, 
        'https://www.amazon.com/Edgedancer-Stormlight-Archive-Brandon-Sanderson-ebook/dp/B06XRHRHPH',
        153
    ),
    new Reading (
        Exp3Abaddon.toString(), 
        'Abaddon\'s Gate (The Expanse 3)',
        Exp3Abaddon, 
        'https://www.amazon.com/Abaddons-Gate-Expanse-James-Corey/dp/0316129070',
        152
    ),
    new Reading (
        OldManWar.toString(), 
        'Old Man\'s War',
        OldManWar, 
        'https://www.amazon.com/Old-Mans-War-John-Scalzi/dp/0765348276',
        151
    ),
    new Reading (
        WhySleep.toString(), 
        'Why We Sleep',
        WhySleep, 
        'https://www.amazon.com/Why-We-Sleep-Matthew-Walker-audiobook/dp/B0752XRB5F',
        150
    ),
    new Reading (
        Exp2Caliban.toString(), 
        'Caliban\'s War (The Expanse 2)',
        Exp2Caliban, 
        'https://www.amazon.com/Calibans-War-Expanse-James-Corey/dp/0316129062',
        149
    ),
    new Reading (
        Arthas.toString(), 
        'World of Warcraft: Arthas - Rise of the Lich King',
        Arthas, 
        'https://www.amazon.com/World-Warcraft-Arthas-Blizzard-Legends/dp/B07P1B1RBP',
        148
    ),
    new Reading (
        RhythmWar.toString(), 
        'Rhythm of War',
        RhythmWar, 
        'https://www.amazon.com/Rhythm-of-War/dp/B082FQRWWR',
        147
    ),
    new Reading (
        Dawnshard.toString(), 
        'Dawnshard',
        Dawnshard, 
        'https://www.amazon.com/Dawnshard-Stormlight-Archive-Brandon-Sanderson-ebook/dp/B08MXXWYT7',
        146
    ),
    new Reading (
        Bakemonogatari2.toString(), 
        'Bakemonogatari 2',
        Bakemonogatari2, 
        'https://www.amazon.com/BAKEMONOGATARI-Part-2-Monster-Tale/dp/1942993897',
        145
    ),
    new Reading (
        Immune.toString(), 
        'Immune',
        Immune, 
        'https://www.amazon.com/Immune-Journey-Mysterious-System-Keeps/dp/0593241312',
        144
    ),
    new Reading (
        Oathbringer.toString(), 
        'Oathbringer',
        Oathbringer, 
        'https://www.amazon.com/Oathbringer-Book-Three-Stormlight-Archive/dp/076532637X',
        143
    ),
    new Reading (
        WordsRadiance.toString(), 
        'Words of Radiance',
        WordsRadiance, 
        'https://www.amazon.com/Words-Radiance-Stormlight-Archive-Book/dp/0765326361',
        142
    ),
    new Reading (
        Exp1Leviathan.toString(), 
        'Leviathan Wakes (The Expanse 1)',
        Exp1Leviathan, 
        'https://www.amazon.com/Leviathan-Wakes-Expanse-Book-1-ebook/dp/B0047Y171G',
        141
    ),
    new Reading (
        Bakemonogatari1.toString(), 
        'Bakemonogatari 1',
        Bakemonogatari1, 
        'https://www.amazon.com/BAKEMONOGATARI-1-Illustrated-VOFAN-NISIOISIN-ebook/dp/B07SGG2ZC4',
        140
    ),
    new Reading (
        WayOfKings.toString(), 
        'The Way of Kings',
        WayOfKings, 
        'https://www.amazon.com/Way-Kings-Brandon-Sanderson/dp/0765365278',
        139
    ),
    new Reading (
        Sandman2.toString(), 
        'The Sandman: Act II',
        Sandman2, 
        'https://www.amazon.com/Audible-The-Sandman-Act-II/dp/B098TWBMJ6',
        138
    ),
    new Reading (
        Sandman.toString(), 
        'The Sandman',
        Sandman, 
        'https://www.amazon.com/The-Sandman/dp/B086WQ7J62',
        137
    ),
    new Reading (
        Stillness.toString(), 
        'Stillness is the Key',
        Stillness, 
        'https://www.amazon.com/Stillness-Key-Ryan-Holiday/dp/0525538585',
        136
    ),
    new Reading (
        DarkAge.toString(), 
        'Dark Age',
        DarkAge, 
        'https://www.amazon.com/Dark-Age-Book-Rising-Saga/dp/0425285944',
        135
    ),
    new Reading (
        IronGold.toString(), 
        'Iron Gold',
        IronGold, 
        'https://www.amazon.com/Iron-Gold-explosive-novel-Rising/dp/147364657X',
        134
    ),
    new Reading (
        MorningStar.toString(), 
        'Morning Star',
        MorningStar, 
        'https://www.amazon.com/Morning-Star-Book-Rising-Saga/dp/0345539842',
        133
    ),
    new Reading (
        GoldenSun.toString(), 
        'Golden Sun',
        GoldenSun, 
        'https://www.amazon.com/Golden-Son-Book-Rising-Saga/dp/0345539834',
        132
    ),
    new Reading (
        RedRising.toString(), 
        'Red Rising',
        RedRising, 
        'https://www.amazon.com/Red-Rising-Pierce-Brown/dp/034553980X',
        131
    ),
    new Reading (
        ThrawnAscendancy3.toString(), 
        'Thrawn Ascendency: Lesser Evil',
        ThrawnAscendancy3, 
        'https://www.amazon.com/Star-Wars-Thrawn-Ascendancy-Lesser/dp/B08ZDSJPHZ/',
        130
    ),
    new Reading (
        PeoplesHistory.toString(), 
        'A People\'s History of the United States',
        PeoplesHistory, 
        'https://www.amazon.com/Peoples-History-United-States/dp/0060838655',
        129
    ),
    new Reading (
        ThrawnAscendancy2.toString(), 
        'Thrawn Ascendency: Greater Good',
        ThrawnAscendancy2, 
        'https://www.amazon.com/Star-Wars-Ascendancy-Greater-Trilogy-ebook/dp/B08KPJW7L9/',
        128
    ),
    new Reading (
        ThrawnTeason.toString(), 
        'Thrawn Treason',
        ThrawnTeason, 
        'https://www.amazon.com/Thrawn-Treason-Star-Wars/dp/1984820982',
        127
    ),
    new Reading (
        AmericaAgain.toString(), 
        'America Again: Re-becoming the Greatness We Never Weren\'t',
        AmericaAgain, 
        'https://www.amazon.com/America-Again-Re-becoming-Greatness-Werent/dp/B01L9GHFIS',
        126
    ),
    new Reading (
        ThrawnAlliances.toString(), 
        'Thrawn: Alliances',
        ThrawnAlliances, 
        'https://www.amazon.com/Thrawn-Alliances-Star-Wars/dp/052548048X',
        125
    ),
    new Reading (
        GenghisKhan.toString(), 
        'Genghis Khan and the Making of the Modern World',
        GenghisKhan, 
        'https://www.amazon.com/Genghis-Khan-Making-Modern-World/dp/1491513705',
        124
    ),
    new Reading (
        Clean.toString(), 
        'Clean: The New Science of Skin',
        Clean, 
        'https://www.amazon.com/Clean-New-Science-Skin/dp/B082MTCYYR',
        123
    ),
    new Reading (
        ThrawnAscendancy1.toString(), 
        'Thrawn Ascendency: Chaos Rising',
        ThrawnAscendancy1, 
        'https://www.amazon.com/Star-Wars-Thrawn-Ascendancy-Trilogy/dp/0593157680',
        122
    ),
    new Reading (
        Thrawn.toString(), 
        'Thrawn',
        Thrawn, 
        'https://www.amazon.com/Thrawn-Star-Wars/dp/1101967021',
        121
    ),
    new Reading (
        ReadyP2.toString(), 
        'Ready Player 2',
        ReadyP2, 
        'https://www.amazon.com/Ready-Player-Two-Ernest-Cline/dp/1524761338',
        120
    ),
    new Reading (
        HailMary.toString(), 
        'Hail Mary',
        HailMary, 
        'https://www.audible.com/pd/Project-Hail-Mary-Audiobook/B08G9PRS1K',
        119
    ),
    new Reading (
        NeverSplit.toString(), 
        'Never Split the Difference',
        NeverSplit, 
        'https://www.amazon.com/Never-Split-Difference-Negotiating-Depended/dp/0062407805',
        118
    ),
    new Reading (
        LordsSith.toString(), 
        'Lords of the Sith',
        LordsSith, 
        'https://www.amazon.com/Lords-of-Sith-Star-Wars-audiobook/dp/B00VRSEEAG/',
        117
    ),
    new Reading (
        PsychZelda.toString(), 
        'The Psychology of Zelda',
        PsychZelda, 
        'https://www.amazon.com/Psychology-Zelda-Linking-World-Legend/dp/1946885347',
        116
    ),
    new Reading (
        LeanStartup.toString(), 
        'The Lean Startup',
        LeanStartup, 
        'https://www.amazon.com/Lean-Startup-Entrepreneurs-Continuous-Innovation/dp/0307887898',
        115
    ),
    new Reading (
        HeavensRiver.toString(), 
        'Heaven\'s River',
        HeavensRiver, 
        'https://www.amazon.com/Heavens-River-Bobiverse-Book-4/dp/B088C51F5H',
        114
    ),
    new Reading (
        AllWorlds.toString(), 
        'All These Worlds',
        AllWorlds, 
        'https://www.amazon.com/All-These-Worlds-Bobiverse-Book-ebook/dp/B0736185ZL',
        113
    ),
    new Reading (
        WeMany.toString(), 
        'For We Are Many',
        WeMany, 
        'https://www.amazon.com/We-Are-Many-Bobiverse-Book-ebook/dp/B01MZI77C0',
        112
    ),
    new Reading (
        WeBob.toString(), 
        'We Are Legion (We Are Bob)',
        WeBob, 
        'https://www.amazon.com/Are-Legion-Bob-Bobiverse-Book-ebook/dp/B01LWAESYQ',
        111
    ),
    new Reading (
        Change.toString(), 
        'Change Agent',
        Change, 
        'https://www.amazon.com/Change-Agent-Daniel-Suarez/dp/110198466X',
        110
    ),
    new Reading (
        Calories.toString(), 
        'Good Calories, Bad Calories',
        Calories, 
        'https://www.amazon.com/Good-Calories-Bad-Controversial-Science/dp/1400033462',
        109
    ),
    new Reading (
        StoneSky.toString(), 
        'The Stone Sky',
        StoneSky, 
        'https://www.amazon.com/Stone-Sky-Broken-Earth-Book-ebook/dp/B01N7EQOFA',
        108
    ),
    new Reading (
        ObeliskGate.toString(), 
        'The Obelisk Gate',
        ObeliskGate, 
        'https://www.amazon.com/Obelisk-Gate-Broken-Earth/dp/0316229261',
        107
    ),
    new Reading (
        FifthSeason.toString(), 
        'The Fifth Season',
        FifthSeason, 
        'https://www.amazon.com/Fifth-Season-Broken-Earth/dp/0316229296',
        106
    ),
    new Reading (
        Freedom.toString(), 
        'Freedom',
        Freedom, 
        'https://www.amazon.com/Freedom-TM-Daemon-Daniel-Suarez/dp/0451231899',
        105
    ),
    new Reading (
        Daemon.toString(), 
        'Daemon',
        Daemon, 
        'https://www.amazon.com/DAEMON-Daemon-Daniel-Suarez/dp/0451228731',
        104
    ),
    new Reading (
        SDVBible.toString(), 
        'Sex, Drugs, Violence and the Bible',
        SDVBible, 
        'https://www.amazon.com/Drugs-Violence-Bible-Chris-Bennett/dp/1550567985',
        103
    ),
    new Reading (
        Watchmen.toString(), 
        'Watchmen',
        Watchmen, 
        'https://www.amazon.com/Watchmen-Alan-Moore/dp/0930289234',
        102
    ),
    new Reading (
        GenerationKill.toString(), 
        'Generation Kill',
        GenerationKill, 
        'https://www.amazon.com/Generation-Kill-Captain-America-American/dp/0425224740/',
        101
    ),
    new Reading (
        Mueller.toString(), 
        'The Mueller Report',
        Mueller, 
        'https://www.audible.com/pd/The-Mueller-Report-Audiobook/B07PXN468K',
        100
    ),
    new Reading (
        Sapiens.toString(), 
        'Sapiens',
        Sapiens, 
        'https://www.amazon.com/Sapiens-Humankind-Yuval-Noah-Harari/dp/0062316095',
        99
    ),
    new Reading (
        RedNotice.toString(), 
        'Red Notice',
        RedNotice, 
        'https://www.amazon.com/Red-Notice-Finance-Murder-Justice/dp/1476755744',
        98
    ),
    new Reading (
        Hokkaido.toString(), 
        'Hokkaido Highway Blues',
        Hokkaido, 
        'https://www.amazon.com/Hokkaido-Highway-Blues-Hitchhiking-Japan/dp/1841952885/',
        97
    ),
    new Reading (
        ReadyPlayer.toString(), 
        'Ready Player One',
        ReadyPlayer, 
        'https://www.amazon.com/Ready-Player-One-Ernest-Cline/dp/0307887448',
        96
    ),
    new Reading (
        IceFire.toString(), 
        'The World of Ice & Fire',
        IceFire, 
        'https://www.amazon.com/World-Ice-Fire-History-Westeros/dp/0553805444',
        95
    ),
    new Reading (
        WorldFat.toString(), 
        'The World is Fat',
        WorldFat, 
        'https://www.amazon.com/World-Fat-Policies-Products-Fattening/dp/1583333819',
        94
    ),
    new Reading (
        FoodRules.toString(), 
        'Food Rules',
        FoodRules, 
        'https://www.amazon.com/Food-Rules-Eaters-Michael-Pollan/dp/014311638X',
        93
    ),
    new Reading (
        RealFood.toString(), 
        'The Real Food Revolution',
        RealFood, 
        'https://www.amazon.com/Real-Food-Revolution-Groceries-American/dp/1401946402',
        92
    ),
    new Reading (
        Subliminal.toString(), 
        'Subliminal',
        Subliminal, 
        'https://www.amazon.com/Subliminal-Your-Unconscious-Rules-Behavior/dp/0307472256/',
        91
    ),
    new Reading (
        GameBelieves.toString(), 
        'The Game Believes in You',
        GameBelieves, 
        'https://www.amazon.com/Game-Believes-You-Digital-Smarter/dp/1137279575/',
        90
    ),
    new Reading (
        Self.toString(), 
        'Self Comes to Mind',
        Self, 
        'https://www.amazon.com/Self-Comes-Mind-Constructing-Conscious/dp/030747495X/',
        89
    ),
    new Reading (
        Thinking.toString(), 
        'Thinking, Fast and Slow',
        Thinking, 
        'https://www.amazon.com/Thinking-Fast-Slow-Daniel-Kahneman/dp/0374533555',
        88
    ),
    new Reading (
        Habit.toString(), 
        'The Power of Habit',
        Habit, 
        'https://www.amazon.com/Power-Habit-What-Life-Business/dp/081298160X',
        87
    ),
    new Reading (
        Wisdom.toString(), 
        'Wisdom',
        Wisdom, 
        'https://www.amazon.com/Wisdom-Philosophy-Neuroscience-Stephen-Hall/dp/0307389685',
        86
    ),
    new Reading (
        Animal.toString(), 
        'Animal Farm',
        Animal, 
        'https://www.amazon.com/Animal-Farm-Anniversary-George-Orwell/dp/0451526341',
        85
    ),
    new Reading (
        Folded.toString(), 
        'The Man Who Folded Himself',
        Folded, 
        'https://www.amazon.com/Man-Who-Folded-Himself/dp/1932100040',
        84
    ),
    new Reading (
        Beyond.toString(), 
        'Beyond Boundaries',
        Beyond, 
        'https://www.amazon.com/Beyond-Boundaries-Neuroscience-Connecting-Machines---/dp/1250002613/',
        83
    ),
    new Reading (
        Nonzero.toString(), 
        'Nonzero',
        Nonzero, 
        'https://www.amazon.com/Nonzero-Logic-Destiny-Robert-Wright/dp/0679758941/',
        82
    ),
    new Reading (
        Healthy.toString(), 
        'Drop Dead Healthy',
        Healthy, 
        'https://www.amazon.com/Drop-Dead-Healthy-Humble-Perfection/dp/1416599088/',
        81
    ),
    new Reading (
        Einstein.toString(), 
        'Einstein',
        Einstein, 
        'https://www.amazon.com/Einstein-Life-Universe-Walter-Isaacson/dp/1442348062',
        80
    ),
    new Reading (
        Colbert.toString(), 
        'I Am America (And So Can You)',
        Colbert, 
        'https://www.amazon.com/Am-America-And-Can-You/dp/0446582182',
        79
    ),
    new Reading (
        Code.toString(), 
        'Code',
        Code, 
        'https://www.amazon.com/Code-Language-Computer-Hardware-Software/dp/0735611319',
        78
    ),
    new Reading (
        America.toString(), 
        'America the Strong',
        America, 
        'https://www.amazon.com/America-Strong-Conservative-Ideas-Generation/dp/1496405935',
        77
    ),
    new Reading (
        Martian.toString(), 
        'The Martian',
        Martian, 
        'https://www.amazon.com/Martian-Andy-Weir/dp/0553418025',
        76
    ),
    new Reading (
        Drive.toString(), 
        'Drive',
        Drive, 
        'https://www.amazon.com/Drive-Surprising-Truth-About-Motivates/dp/1594484805',
        75
    ),
    new Reading (
        SeventeenSevenitySix.toString(), 
        '1776',
        SeventeenSevenitySix, 
        'https://www.amazon.com/1776-David-McCullough/dp/0743226720',
        74
    ),
    new Reading (
        ManPlay.toString(), 
        'Man, Play and Games',
        ManPlay, 
        'https://www.amazon.com/Man-Play-Games-Roger-Caillois/dp/025207033X',
        73
    ),
    new Reading (
        Neighbors.toString(), 
        'Neighbors and Wise Men',
        Neighbors, 
        'https://www.amazon.com/Neighbors-Wise-Men-Encounters-Unexpected/dp/B00BJZGRGG',
        72
    ),
    new Reading (
        OneHundredTwentyYear.toString(), 
        'Beyond the 120 Year Diet',
        OneHundredTwentyYear, 
        'https://www.amazon.com/Beyond-120-Year-Diet-Double/dp/1568581572',
        71
    ),
    new Reading (
        KillingKennedy.toString(), 
        'Killing Kennedy',
        KillingKennedy, 
        'https://www.amazon.com/Killing-Kennedy-The-End-Camelot/dp/1427226849',
        70
    ),
    new Reading (
        BeerHell.toString(), 
        'I Hope They Serve Beer in Hell',
        BeerHell, 
        'https://www.amazon.com/Hope-They-Serve-Beer-Hell/dp/0806532254',
        69
    ),
    new Reading (
        MindsOnline.toString(), 
        'Minds Online',
        MindsOnline, 
        'https://www.amazon.com/Minds-Online-Teaching-Effectively-Technology/dp/067436824X',
        68
    ),
    new Reading (
        BoysBoat.toString(), 
        'The Boys in the Boat',
        BoysBoat, 
        'https://www.amazon.com/Boys-Boat-Americans-Berlin-Olympics/dp/0143125478',
        67
    ),
    new Reading (
        GunsGerms.toString(), 
        'Guns, Germs, and Steel',
        GunsGerms, 
        'https://www.amazon.com/Guns-Germs-Steel-Fates-Societies/dp/0393317552',
        66
    ),
    new Reading (
        OneSecond.toString(), 
        'One Second After',
        OneSecond, 
        'https://www.amazon.com/One-Second-After-William-Forstchen/dp/0765356864',
        65
    ),
    new Reading (
        DesignThings.toString(), 
        'The Design of Everyday Things',
        DesignThings, 
        'https://www.amazon.com/Design-Everyday-Things-Donald-Norman/dp/0465067107',
        64
    ),
    new Reading (
        GamificationLearning.toString(), 
        'The Gamification of Learning and Instruction',
        GamificationLearning, 
        'https://www.amazon.com/Gamification-Learning-Instruction-Game-based-Strategies/dp/1118096347',
        63
    ),
    new Reading (
        Cooked.toString(), 
        'Cooked',
        Cooked, 
        'https://www.amazon.com/Cooked-Natural-Transformation-Michael-Pollan/dp/0143125338',
        62
    ),
    new Reading (
        StoryMuhammed.toString(), 
        'The Story of Muhammed',
        StoryMuhammed, 
        'https://www.amazon.com/Story-Mohammed-Islam-Unveiled/dp/1496019334',
        61
    ),
    new Reading (
        Incognito.toString(), 
        'Incognito',
        Incognito, 
        'https://www.amazon.com/Incognito-Secret-Lives-David-Eagleman/dp/0307389928',
        60
    ),
    new Reading (
        Alchemist.toString(), 
        'The Alchemist',
        Alchemist, 
        'https://www.amazon.com/Alchemist-Graphic-Novel-Paulo-Coelho/dp/0062024329',
        59
    ),
    new Reading (
        SpontaneousEvolution.toString(), 
        'Spontaneous Evolution',
        SpontaneousEvolution, 
        'https://www.amazon.com/Spontaneous-Evolution-Positive-Future-There/dp/1401926312',
        58
    ),
    new Reading (
        DanceDragons.toString(), 
        'A Dance With Dragons',
        DanceDragons, 
        'https://www.amazon.com/Dance-Dragons-Song-Ice-Fire/dp/0553582011',
        57
    ),
    new Reading (
        DavidGoliath.toString(), 
        'David and Goliath',
        DavidGoliath, 
        'https://www.amazon.com/David-Goliath-Underdogs-Misfits-Battling/dp/0316204374',
        56
    ),
    new Reading (
        FeastCrows.toString(), 
        'A Feast for Crows',
        FeastCrows, 
        'https://www.amazon.com/Feast-Crows-Song-Fire-Thrones/dp/055358202X',
        55
    ),
    new Reading (
        Flow.toString(), 
        'Flow',
        Flow, 
        'https://www.amazon.com/Flow-Psychology-Experience-Perennial-Classics/dp/0061339202',
        54
    ),
    new Reading (
        StormSwords.toString(), 
        'A Storm of Swords',
        StormSwords, 
        'https://www.amazon.com/Storm-Swords-Song-Fire-Book/dp/055357342X',
        53
    ),
    new Reading (
        IntelNature.toString(), 
        'The Intelligibility of Nature',
        IntelNature, 
        'https://www.amazon.com/Intelligibility-Nature-Science-Makes-science-culture/dp/0226139492',
        52
    ),
    new Reading (
        ClashKings.toString(), 
        'A Clash of Kings',
        ClashKings, 
        'https://www.amazon.com/Clash-Kings-Song-Fire-Book/dp/0553579908',
        51
    ),
    new Reading (
        Vehicles.toString(), 
        'Vehicles',
        Vehicles, 
        'https://www.amazon.com/Vehicles-Experiments-Psychology-Valentino-Braitenberg/dp/0262521121',
        50
    ),
    new Reading (
        GameThrones.toString(), 
        'A Game of Thrones',
        GameThrones, 
        'https://www.amazon.com/Game-Thrones-Song-Fire-Book/dp/0553593714',
        49
    ),
    new Reading (
        CompassPleasure.toString(), 
        'The Compass of Pleasure',
        CompassPleasure, 
        'https://www.amazon.com/Compass-Pleasure-Exercise-Marijuana-Generosity/dp/0143120751',
        48
    ),
    new Reading (
        SelfishGene.toString(), 
        'The Selfish Gene',
        SelfishGene, 
        'https://www.amazon.com/Selfish-Gene-Anniversary----Introduction/dp/0199291152',
        47
    ),
    new Reading (
        StrokeInsight.toString(), 
        'My Stroke of Insight',
        StrokeInsight, 
        'https://www.amazon.com/My-Stroke-Insight-Scientists-Personal/dp/0452295548',
        46
    ),
    new Reading (
        GameFrame.toString(), 
        'Game Frame',
        GameFrame, 
        'https://www.amazon.com/Game-Frame-Using-Strategy-Success/dp/1451611064',
        45
    ),
    new Reading (
        SuperFreak.toString(), 
        'Super Freakonomics',
        SuperFreak, 
        'https://www.amazon.com/SuperFreakonomics-Cooling-Patriotic-Prostitutes-Insurance/dp/0060889586',
        44
    ),
    new Reading (
        Nausea.toString(), 
        'Nausea',
        Nausea, 
        'https://www.amazon.com/Nausea-Directions-Paperbook-Jean-Paul-Sartre/dp/0811220303',
        43
    ),
    new Reading (
        ThinAir.toString(), 
        'Into Thin Air',
        ThinAir, 
        'https://www.amazon.com/Into-Thin-Air-Personal-Disaster/dp/0385494785',
        42
    ),
    new Reading (
        HistoryTime.toString(), 
        'A Brief History of Time',
        HistoryTime, 
        'https://www.amazon.com/Brief-History-Time-Stephen-Hawking/dp/0553380168',
        41
    ),
    new Reading (
        EngineeringPlay.toString(), 
        'Engineering Play',
        EngineeringPlay, 
        'https://www.amazon.com/Engineering-Play-Childrens-Catherine-Foundation/dp/0262517388',
        40
    ),
    new Reading (
        SearchSchrodinger.toString(), 
        'In Search of Schrodinger\'s Cat',
        SearchSchrodinger, 
        'https://www.amazon.com/Search-Schr%C3%B6dingers-Cat-Quantum-Physics/dp/0553342533',
        39
    ),
    new Reading (
        SunsetLimited.toString(), 
        'The Sunset Limited',
        SunsetLimited, 
        'https://www.amazon.com/Sunset-Limited-Novel-Dramatic-Form/dp/0307278360',
        38
    ),
    new Reading (
        Comics.toString(), 
        'Understanding Comics',
        Comics, 
        'https://www.amazon.com/Understanding-Comics-Invisible-Scott-McCloud/dp/006097625X',
        37
    ),
    new Reading (
        Secret.toString(), 
        'The Secret',
        Secret, 
        'https://www.amazon.com/Secret-Rhonda-Byrne/dp/1582701709',
        36
    ),
    new Reading (
        Imagine.toString(), 
        'Imagine',
        Imagine, 
        'https://www.amazon.com/Imagine-Creativity-Works-Jonah-Lehrer/dp/B007QRI1UQ',
        35
    ),
    new Reading (
        Mindsight.toString(), 
        'Mindsight',
        Mindsight, 
        'https://www.amazon.com/Mindsight-New-Science-Personal-Transformation/dp/0553386395',
        34
    ),
    new Reading (
        ProgramProgrammed.toString(), 
        'Program or Be Programmed',
        ProgramProgrammed, 
        'https://www.amazon.com/Program-Be-Programmed-Commands-Digital/dp/159376426X',
        33
    ),
    new Reading (
        ProdigalGod.toString(), 
        'The Prodigal God',
        ProdigalGod, 
        'https://www.amazon.com/Prodigal-God-Timothy-Keller/dp/1594484023',
        32
    ),
    new Reading (
        Freakonomics.toString(), 
        'Freakonomics',
        Freakonomics, 
        'https://www.amazon.com/Freakonomics-Economist-Explores-Hidden-Everything/dp/0060731338',
        31
    ),
    new Reading (
        HeavenReal.toString(), 
        'Heaven is for Real',
        HeavenReal, 
        'https://www.amazon.com/Heaven-Real-Little-Astounding-Story/dp/0849946158',
        30
    ),
    new Reading (
        RealityBroken.toString(), 
        'Reality is Broken',
        RealityBroken, 
        'https://www.amazon.com/Reality-Broken-Better-McGonigal-Hardcover/dp/B00BQ1YTA4',
        29
    ),
    new Reading (
        Blink.toString(), 
        'Blink',
        Blink, 
        'https://www.amazon.com/Blink-Power-Thinking-Without/dp/0316010669',
        28
    ),
    new Reading (
        BeakFinch.toString(), 
        'The Beak of the Finch',
        BeakFinch, 
        'https://www.amazon.com/Beak-Finch-Story-Evolution-Time/dp/067973337X',
        27
    ),
    new Reading (
        Dune.toString(), 
        'Dune',
        Dune, 
        'https://www.amazon.com/Dune-Frank-Herbert/dp/0441172717',
        26
    ),
    new Reading (
        ArtHappiness.toString(), 
        'The Art of Happiness',
        ArtHappiness, 
        'https://www.amazon.com/Art-Happiness-10th-Anniversary-Handbook-ebook/dp/B002UK6NO0',
        25
    ),
    new Reading (
        ArtWar.toString(), 
        'The Art of War',
        ArtWar, 
        'https://www.amazon.com/Art-War-Sun-Tzu/dp/1599869772',
        24
    ),
    new Reading (
        Decoded.toString(), 
        'Decoded',
        Decoded, 
        'https://www.amazon.com/Decoded-Jay-Z/dp/1400068924',
        23
    ),
    new Reading (
        Earth.toString(), 
        'Earth',
        Earth, 
        'https://www.amazon.com/Daily-Show-Stewart-Presents-Earth/dp/044657922X',
        22
    ),
    new Reading (
        DoubleHelix.toString(), 
        'The Double Helix',
        DoubleHelix, 
        'https://www.amazon.com/Double-Helix-Personal-Discovery-Structure/dp/074321630X',
        21
    ),
    new Reading (
        Outliers.toString(), 
        'Outliers',
        Outliers, 
        'https://www.amazon.com/Outliers-Story-Success-Malcolm-Gladwell/dp/0316017930',
        20
    ),
    new Reading (
        TippingPoint.toString(), 
        'The Tipping Point',
        TippingPoint, 
        'https://www.amazon.com/Tipping-Point-Little-Things-Difference/dp/0316346624',
        19
    ),
    new Reading (
        OmnivoreDilemma.toString(), 
        'The Omnivore\'s Dilemma',
        OmnivoreDilemma, 
        'https://www.amazon.com/Omnivores-Dilemma-Secrets-Behind-Readers/dp/0803735006',
        18
    ),
    new Reading (
        ShadowGiant.toString(), 
        'Shadow of the Giant',
        ShadowGiant, 
        'https://www.amazon.com/Shadow-Giant-Orson-Scott-Card/dp/0812571398',
        17
    ),
    new Reading (
        ShadowPuppets.toString(), 
        'Shadow Puppets',
        ShadowPuppets, 
        'https://www.amazon.com/Shadow-Puppets-Orson-Scott-Card/dp/0765340054',
        16
    ),
    new Reading (
        ShadowHegemon.toString(), 
        'Shadow of the Hegemon',
        ShadowHegemon, 
        'https://www.amazon.com/Shadow-Hegemon-Orson-Scott-Card/dp/0812565959',
        15
    ),
    new Reading (
        EnderShadow.toString(), 
        'Ender\'s Shadow',
        EnderShadow, 
        'https://www.amazon.com/Enders-Shadow-Orson-Scott-Card/dp/0812575717',
        14
    ),
    new Reading (
        ChildrenMind.toString(), 
        'Children of the Mind',
        ChildrenMind, 
        'https://www.amazon.com/Children-Ender-Quintet-Orson-Scott/dp/0812522397',
        13
    ),
    new Reading (
        Xenocide.toString(), 
        'Xenocide',
        Xenocide, 
        'https://www.amazon.com/Xenocide-Quintet-Orson-Scott-Card/dp/0812509250',
        12
    ),
    new Reading (
        SpeakerDead.toString(), 
        'Speaker for the Dead',
        SpeakerDead, 
        'https://www.amazon.com/Speaker-Ender-Quintet-Orson-Scott/dp/0812550757',
        11
    ),
    new Reading (
        EndersGame.toString(), 
        'Ender\'s Game',
        EndersGame, 
        'https://www.amazon.com/Enders-Ender-Quintet-Orson-Scott/dp/0812550706',
        10
    )
];